import flatten from 'flat';
import ms from 'ms';
// const getDateDepend = (form,date_depend_field)=>{

// const flatten_form = flatten(form)
// const found = Object.keys(flatten_form).find(key=>flatten_form[key]===date_depend_field);
// const fieldName = found.replace('field_id','field_value');
// return (flatten_form.hasOwnProperty(fieldName)) ? (flatten_form[found.replace('field_id','field_value')]):new Date();
        
// }
const getDateDepend = (form, date_depend_field) => {
    const flatten_form = flatten(form);
    
    // Extract the field name from date_depend_field
    const fieldName = date_depend_field.split('/')[0];
    
    const found = Object.keys(flatten_form).find(key => 
      flatten_form[key] === fieldName && key.endsWith('field_id')
    );

    // if (found) {
    //   const valueKey = found.replace('field_id', 'field_value');
    //   console.log('valueKey',valueKey,flatten_form[valueKey])
    //   return flatten_form.hasOwnProperty(valueKey) ? flatten_form[valueKey] : new Date();
    // }
    if (found) {
      const baseKey = found.replace('field_id', 'field');
      const valueKey = `${baseKey}_value`;
      const dateMinKey = `${baseKey}_date_min`;
      const dateMaxKey = `${baseKey}_date_max`;
  
      
      if (flatten_form.hasOwnProperty(valueKey)) {
        return flatten_form[valueKey];
      } else if (flatten_form.hasOwnProperty(dateMinKey)) {
        return flatten_form[dateMinKey];
      } else if (flatten_form.hasOwnProperty(dateMaxKey)) {
        return flatten_form[dateMaxKey];
      }
    }
    
    return new Date();
  }


const getMinMaxDate = (date_depend,unit,min,max)=>{
    const minsec = ms(min+unit);
    const maxsec = ms(max+unit);
   
    const min_date = new Date(+new Date(date_depend)-minsec);
    const max_date = new Date(+new Date(date_depend)+maxsec);
    return {min_date,max_date}
}
export {getDateDepend,getMinMaxDate}